export default "__VITE_ASSET__DPX0h69S__"